import { initDatadog as initSharedDatadog } from '@susu/datadog'

import { version } from '../../package.json'
import { datadogConfig } from '../config/datadog.config'

type Environment = 'tst' | 'acc' | 'prd'

export async function initDatadog(
  env: Environment,
): Promise<(() => void) | undefined> {
  if (typeof window === 'undefined') {
    return undefined
  }

  try {
    const { cleanup } = await initSharedDatadog({
      ...datadogConfig,
      env,
      version,
    })
    return cleanup
  } catch (error) {
    console.error('Failed to initialize Datadog RUM:', error)
    return undefined
  }
}
